export const PASSPORT_REQUEST = 'PASSPORT_REQUEST';
export const PASSPORT_REQUEST_SUCCESS = 'PASSPORT_REQUEST_SUCCESS';
export const PASSPORT_REQUEST_ERROR = 'PASSPORT_REQUEST_ERROR';

export const SELECTED_PRESCRIPTION_ID = 'SELECTED_PRESCRIPTION_ID';
export const SELECTED_PRESCRIPTION_ID_SUCCESS = 'SELECTED_PRESCRIPTION_ID_SUCCESS';
export const SELECTED_PRESCRIPTION_ID_ERROR = 'SELECTED_PRESCRIPTION_ID_ERROR';


export const PASSPORT_FILE_OPEN = 'PASSPORT_FILE_OPEN';

export const SELECTED_HEALTH_REC_ID = 'SELECTED_HEALTH_REC_ID';
export const SELECTED_HEALTH_REC_ID_SUCCESS = 'SELECTED_HEALTH_REC_ID_SUCCESS';
export const SELECTED_HEALTH_REC_ID_ERROR = 'SELECTED_HEALTH_REC_ID_ERROR';